import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';
import ImageSlider from '../components/ImageSlider';
import img1 from '../assets/card2.png';
import img2 from '../assets/meezan_mobile_banking_screenshot.png';
import img3 from '../assets/deposit_check.png';
import BankAccountInfoCard from '../components/BankAccountInfoCard';
import { getOnlinePaymentAccounts } from '../apiServices/apiServices';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import CustomToastContainer from '../components/CustomToastContainer';
import { contactUs } from '../apiServices/apiServices';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from 'react-router-dom';

const OnlineTopup = () => {
    const navigate = useNavigate();
    const [data, setData] = useState([]);
    const [whatsapp, setWhatsapp] = useState('');

    useEffect(() => {
        const fetchData = async () => {
          await fetchOnlinePaymentAccounts();
          await contactUsMethod();
        };
    
        fetchData();
      }, []);

    const openWhatsApp = () => {
      // const url = `whatsapp://send?phone=${whatsapp}`;
      const url = `https://wa.me/${whatsapp}`;
      window.open(url, '_blank'); 
    };
    
    const contactUsMethod = async () => {
      try {
        const response = await contactUs();
        // console.log("Contact Us API Response:", response);
        if (response && response.success) {
          const { contactNumbersService } = response.data;
          setWhatsapp(contactNumbersService?.[0]?.value || 'Not available');
      } else {
          toast.error(response?.message || 'Something went wrong.');
        }
      } catch (error) {
        console.error("Error occurred:", error);
        toast.error('An error occurred. Please try again.');
      }
    };
    const fetchOnlinePaymentAccounts = async () => {
      try {
        const response = await getOnlinePaymentAccounts();
        if (response && response.success) {
          setData(response.data.bankAccountsservice
            || []);
        } else {
          console.log(response.message)
          toast.error(response.message || 'Failed to fetch accounts');
        }
      } catch (error) {
        console.error('Error:', error);
        toast.error('An error occurred. Please try again.');
      }
    };

      const handleNavigation = (path) => {
        navigate(path);
      };
    
  return (
    <>
      <div className="flex flex-col h-screen w-full">
        <nav className="flex items-center justify-between p-2 sm:p-4 bg-white shadow-md">
          <button className="text-gray-600 items-center" onClick={() => handleNavigation(-1)}>
            <FontAwesomeIcon icon={faArrowLeft} size="lg" />
          </button>
          <div className="flex items-center justify-center flex-grow gap-2">
            <h1 className="text-gray-600 font-semibold text-lg">
            Online Topup
            </h1>
          </div>
        </nav>       

        <div className=" bg-red-500 rounded-lg  relative ">
            <div className="mx-8 my-4">
                <ImageSlider images={[img1, img2, img3 ]} />
            </div>
        </div>

        <div className="flex flex-col w-full h-full bg-gray-200  relative">
          <div className="flex-1">
            {
                data && data.map((item) => (
                    <div key={item.id}>
                        <BankAccountInfoCard account={item}/>
                    </div>
                ))
            }
            </div>
            <div className="flex items-center justify-center m-5">
              <button onClick={openWhatsApp} className="w-full  py-4 text-lg border border-green-500 text-green-500 bg-white bottom-4 rounded-lg flex items-center justify-center space-y-1 md:space-y-0 md:space-x-5">
                <FontAwesomeIcon icon={faWhatsapp} size="xl" className="text-green-500" />  
                <span className="flex justify-center ms-2 font-semibold">Share Receipt on WhatsApp</span> 
              </button>
            </div>
          </div>
        </div>
        <CustomToastContainer/>
    </>
  );
};

export default OnlineTopup;
